import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'

export const AMCraftDialog = (props: Params) => {
  return <Layout {...useProps(props)} />
}
